import "./safetyquiz-block.scss";
import quizResultTemplate from "./SafetyQuiz.hbs";

(function () {
    if (document.querySelectorAll(".js-safetyquiz-block").length > 0) {

        const safetyQuiz = {
            store: {
                currentQuizBlock: null,
                data: null,
            },
            init: function () {
                this.addEvents();
            },
            addEvents: () => {
                const quizBlocks = document.querySelectorAll(".js-quiz-content");

                quizBlocks.forEach((quizBlock) => {
                    const inputs = quizBlock.querySelectorAll("input[type='radio']");
                    const showResultsButtons = quizBlock.querySelectorAll(
                        ".js-quiz-results-show"
                    );

                    const errorMessage = quizBlock.querySelector(".js-quiz-error");

                    if (showResultsButtons.length > 0) {
                        showResultsButtons.forEach((showResultsButton) => {
                            showResultsButton.addEventListener("click", (e) => {
                                let inputCount = 0;
                                let checkedInputs = 0;
                                let checkedYes = 0;
                                const contentLink = e.target.dataset.contentlink;

                                inputs.forEach((input) => {
                                    if (input.checked) {
                                        checkedInputs++;

                                        if (input.value == 1) {
                                            checkedYes++;
                                        }
                                    }

                                    inputCount++;
                                });

                                inputCount = inputCount / 2;

                                if (checkedInputs < inputCount) {
                                    errorMessage.classList.add("visible");
                                } else {
                                    errorMessage.classList.remove("visible");
                                    safetyQuiz.store.currentQuizBlock = quizBlock;
                                    safetyQuiz.fetchData(contentLink, checkedYes);
                                }
                            });
                        });
                    }
                });
            },
            fetchData: (contentLink, checkedYes) => {
                fetch(`/api/safetyquiz/GetResult?contentlink=${contentLink}&yescount=${checkedYes}&lang=${document.documentElement.lang}`)
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                        }
                        return response.json();
                    })
                    .then((data) => {
                        safetyQuiz.store.data = data;
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                    .finally(() => {
                        safetyQuiz.renderTemplate(contentLink, safetyQuiz.store.data);
                    });
            },
            renderTemplate: (contentLink, data) => {
                let target = document.querySelector(
                    "[data-contentlink='" + contentLink + "']"
                );

                target = target.querySelector(".js-quiz-content");
                target.innerHTML = quizResultTemplate(data);
                const quizIndicator = target.querySelector(".js-quiz-indicator");

                setTimeout(function () {
                    switch (data.riskLevel) {
                        case "Low":
                            quizIndicator.style.left = "calc(20% - 21px)";
                            break;
                        case "Medium":
                            quizIndicator.style.left = "calc(50% - 21px)";
                            break;
                        case "High":
                            quizIndicator.style.left = "calc(80% - 21px)";
                            break;
                        default:
                            quizIndicator.style.left = "calc(20% - 21px)";
                    }
                }, 500);
            },
        };

        safetyQuiz.init();
    }
})();
